import React, { useState } from "react";
import ModalBox from "../../components/modal/ModalBox";
import useButtonLoader from "../../hooks/UseButtonLoader";
import { Input, TextArea } from "../../components/Form";
import { addFaqApi } from "../../services/faq";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";

const AddFaq = ({ show, close, listing }) => {
  const [buttonref, buttonLoader] = useButtonLoader("Add");
  const [input, setInput] = useState({ title: "", description: "" });
  const [error, setError] = useState({});

  //--------validation---------------
  const validation = () => {
    let status = true;
    let errorMessage = {};

    if (!input?.title) {
      errorMessage["title"] = "Please enter title";
      status = false;
    }
    if (!input?.description) {
      errorMessage["description"] = "Please enter description";
      status = false;
    }

    setError(errorMessage);
    return status;
  };
  //--------------change-handle------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "title" || name === "description") {
      let cleanedName = value.replace(/^[ \n]+/g, "");
      setInput({ ...input, [name]: cleanedName });
    }
  };
  //------------------modal-close--------------------------
  const modalClose = () => {
    close();
    setInput({ title: "", description: "" });
    setError({});
  };
  //--------------Add-sub-category------------------------
  const addFaq = async () => {
    const status = validation();
    if (status) {
      try {
        buttonLoader(true);
        const res = await addFaqApi(input);
        if (res.data.status === 200) {
          successMessage(res);
          close(false);
          listing();
          buttonLoader(false);
          setInput({ title: "", description: "" });
        } else {
          elseMessage(res);
          buttonLoader(false);
        }
      } catch (e) {
        catchMessage(e);
        buttonLoader(false);
      }
    }
  };

  return (
    <ModalBox
      status={show}
      onClose={modalClose}
      title="Add FAQ"
      closeIcon
      custom
      customizedFooter={
        <button className="btn_size" ref={buttonref} onClick={addFaq}>
          Add
        </button>
      }
    >
      <Input
        type="text"
        name="title"
        className="form-control"
        label="Title"
        placeholder="Enter title"
        value={input?.title || ""}
        onChange={handleChange}
        maxLength={200}
        error={error.title}
      />
      <TextArea
        name="description"
        className="form-control"
        label="Description"
        placeholder="Enter description"
        value={input?.description || ""}
        onChange={handleChange}
        // maxLength={100}
        error={error.description}
      />
    </ModalBox>
  );
};

export default AddFaq;
